import React from 'react';

import { Text } from '@rbilabs/universal-components';
import { View } from 'react-native';

import { t } from 'state/intl/translations';

const Bullet = ({ label, value }: { label: string; value: string }) => (
  <View style={{ marginBottom: 8 }}>
    <Text variant="body" fontWeight="bold">
      • {label}{' '}
      <Text variant="body" fontWeight="normal">
        {value}
      </Text>
    </Text>
  </View>
);

export const DeliveryTermsUS = () => {
  return (
    <>
      <Text variant="headerThree" mb="$4">
        {t('deliveryTerms.title')}
      </Text>
      <Text variant="body" mb="$4">
        {t('deliveryTerms.intro')}
      </Text>

      {/* All states */}
      <Text variant="headerThree" mb="$2">
        {t('deliveryTerms.statesHeading')}
      </Text>
      <View style={{ paddingLeft: 16 }}>
        <Bullet label={t('deliveryTerms.feeLabel')} value={t('deliveryTerms.feeValue')} />
        <Bullet
          label={t('deliveryTerms.serviceFeeLabel')}
          value={t('deliveryTerms.serviceFeeValue')}
        />
        <Bullet
          label={t('deliveryTerms.smallCartLabel')}
          value={t('deliveryTerms.smallCartValue')}
        />
      </View>

      {/* Colorado */}
      <Text variant="headerThree" mt="$4" mb="$2">
        {t('deliveryTerms.coloradoHeading')}
      </Text>
      <View style={{ paddingLeft: 16 }}>
        <Bullet label={t('deliveryTerms.feeLabel')} value={t('deliveryTerms.feeValue')} />
        <Bullet
          label={t('deliveryTerms.serviceFeeLabel')}
          value={t('deliveryTerms.serviceFeeValue')}
        />
        <Bullet
          label={t('deliveryTerms.smallCartLabel')}
          value={t('deliveryTerms.smallCartValue')}
        />
        <Bullet
          label={t('deliveryTerms.retailFeeLabel')}
          value={t('deliveryTerms.retailFeeValue')}
        />
      </View>

      {/* California */}
      <Text variant="headerThree" mt="$4" mb="$2">
        {t('deliveryTerms.californiaHeading')}
      </Text>
      <View style={{ paddingLeft: 16 }}>
        <Bullet label={t('deliveryTerms.feeLabel')} value={t('deliveryTerms.caFeeValue')} />
        <Bullet
          label={t('deliveryTerms.serviceFeeLabel')}
          value={t('deliveryTerms.serviceFeeValue')}
        />
        <Bullet
          label={t('deliveryTerms.smallCartLabel')}
          value={t('deliveryTerms.smallCartValue')}
        />
      </View>
    </>
  );
};
